define('adminColorSelectionsEditPopupView',[
  'app',
  'module',
  'underscore',
  'jquery',
  'marionette',
  'windows',
  'template!adminColorSelectionsEditPopupView',
  'entities/admin/color_selections'
], function (
  App,
  Module,
  _,
  $,
  Marionette,
  Windows,
  Tpl
) {
  'use strict';

  var PAGE_SIZE = 60;

  var colorKey = function (c) {
    return c.code ? 'p|' + (c.library || '') + '|' + c.code : 'h|' + (c.hex || '').toLowerCase();
  };

  var normalizeHex = function (value) {
    var h = $.trim(value || '').toLowerCase().replace(/^#/, '');
    if (/^[0-9a-f]{3}$/.test(h)) {
      h = h.charAt(0) + h.charAt(0) + h.charAt(1) + h.charAt(1) + h.charAt(2) + h.charAt(2);
    }
    return /^[0-9a-f]{6}$/.test(h) ? '#' + h : null;
  };

  // Editor of one colour selection: its colours are spot colours picked from
  // the libraries or plain RGB values. Linking to imprint technologies is done
  // on the technique (or in the Excel Techniques sheet), shown here read-only.
  var View = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'admin-color-selections-popup-edit-view',

    ui: {
      code: '.js-code',
      name: '.js-name',
      description: '.js-description',
      colors: '.js-colors',
      count: '.js-count',
      library: '.js-library',
      pantoneSearch: '.js-pantone-search',
      results: '.js-results',
      rgbPicker: '.js-rgb-picker',
      rgbHex: '.js-rgb-hex',
      techniques: '.js-techniques',
      error: '.js-error',
      save: '.js-save'
    },

    events: {
      'input @ui.pantoneSearch': 'onSearchInput',
      'change @ui.library': 'searchPantones',
      'click .js-result': 'onAddPantone',
      'click .js-remove': 'onRemove',
      'input @ui.rgbPicker': 'onPickerChange',
      'input @ui.rgbHex': 'onHexInput',
      'click .js-rgb-add': 'onAddRgb',
      'click .js-save': 'onSave',
      'click .js-close': 'onClose'
    },

    initialize: function () {
      this.secId = this.options.selectionSecId || null;
      this.data = { code: '', name: '', description: '', colors: [], techniques: [] };
    },

    serializeData: function () {
      return _.extend({}, this.data, {
        labels: {
          code: _.i18n('admin.colorSelections.code', null, 'Code'),
          name: _.i18n('admin.colorSelections.name', null, 'Name'),
          description: _.i18n('admin.colorSelections.description', null, 'Description'),
          colors: _.i18n('admin.colorSelections.colors', null, 'Colours'),
          addPantone: _.i18n('admin.colorSelections.addPantone', null, 'Add a spot colour'),
          allLibraries: _.i18n('admin.colorSelections.allLibraries', null, 'All libraries'),
          pantonePlaceholder: _.i18n('admin.colorSelections.pantonePlaceholder', null, 'Code or name, e.g. 185 or reflex'),
          addRgb: _.i18n('admin.colorSelections.addRgb', null, 'Add a plain colour'),
          rgbHint: _.i18n('admin.colorSelections.rgbHint', null,
            'Only when the technique does not print spot colours (e.g. a laser shade or a thread colour).'),
          add: _.i18n('common.add', null, 'Add'),
          techniques: _.i18n('admin.colorSelections.usedBy', null, 'Offered by'),
          techniquesHint: _.i18n('admin.colorSelections.usedByHint', null,
            'Link a selection on the imprint technology (Admin → Imprint technologies) or in the Techniques sheet of the Excel file.'),
          save: _.i18n('common.save', null, 'Save'),
          close: _.i18n('common.close', null, 'Close')
        }
      });
    },

    onShow: function () {
      var self = this;
      App.request('colorSelections:libraries').done(function (libraries) {
        if (self.isDestroyed) { return; }
        _.each(libraries || [], function (library) {
          self.ui.library.append($('<option/>').attr('value', library).text(library));
        });
      });
      if (this.secId) {
        App.request('colorSelections:get', this.secId).done(function (json) {
          if (self.isDestroyed) { return; }
          self.data = {
            code: json.code || '',
            name: json.name || '',
            description: json.description || '',
            colors: json.colors || [],
            techniques: json.techniques || []
          };
          self.ui.code.val(self.data.code);
          self.ui.name.val(self.data.name);
          self.ui.description.val(self.data.description);
          self.renderColors();
          self.renderTechniques();
        }).fail(function () {
          self.showError(_.i18n('common.error', null, 'Something went wrong. Please try again.'));
        });
      }
      this.renderColors();
      this.renderTechniques();
      this.searchPantones();
    },

    onDestroy: function () {
      clearTimeout(this.searchTimer);
    },

    // ---- colours ---------------------------------------------------------
    renderColors: function () {
      var colors = this.data.colors;
      this.ui.count.text('(' + colors.length + ')');
      if (!colors.length) {
        this.ui.colors.html('<div class="cs-empty">' + _.escape(_.i18n('admin.colorSelections.noColors', null,
          'No colour yet: search a spot colour below, or add a plain one.')) + '</div>');
        return;
      }
      this.ui.colors.html(_.map(colors, function (c, index) {
        return '<div class="cs-chip" title="' + _.escape((c.library ? c.library + ' — ' : '') + (c.code || c.hex)) + '">' +
          '<span class="cs-swatch" style="background:' + _.escape(c.hex || '#fff') + '"></span>' +
          '<span class="cs-chip-text"><span class="cs-chip-code">' + _.escape(c.code || (c.hex || '').toUpperCase()) + '</span>' +
          '<span class="cs-chip-lib">' + _.escape(c.library || _.i18n('admin.colorSelections.rgb', null, 'RGB')) +
          (c.custom ? ' · ' + _.escape(_.i18n('admin.colorSelections.custom', null, 'your account')) : '') + '</span></span>' +
          '<button type="button" class="cs-remove js-remove" data-index="' + index + '">×</button></div>';
      }).join(''));
      if (colors.length === 1) {
        // PrintZone.isFixedFilling: one colour in the selection = the zone prints it, no choice.
        this.ui.colors.append('<div class="cs-hint cs-single">' + _.escape(_.i18n('admin.colorSelections.single', null,
          'A single colour: zones of the techniques offering this selection will print it without asking.')) + '</div>');
      }
    },

    renderTechniques: function () {
      var techniques = this.data.techniques;
      if (!techniques.length) {
        this.ui.techniques.html('<span class="cs-empty">' +
          _.escape(_.i18n('admin.colorSelections.unused', null, 'Not used')) + '</span>');
        return;
      }
      this.ui.techniques.html(_.map(techniques, function (t) {
        return '<span class="cs-technique" title="' + _.escape(t.name || '') + '"><b>' + _.escape(t.code) + '</b>' +
          (t.name ? ' ' + _.escape(t.name) : '') +
          (t.allowOtherColors ? '' : ' <i class="fa fa-lock" title="' +
            _.escape(_.i18n('admin.colorSelections.restricted', null, 'Only the colours of the selection')) + '"></i>') +
          '</span>';
      }).join(''));
    },

    addColor: function (color) {
      var key = colorKey(color);
      if (_.find(this.data.colors, function (c) { return colorKey(c) === key; })) {
        this.flash(key);
        return;
      }
      this.data.colors.push(color);
      this.renderColors();
      this.ui.colors.scrollTop(this.ui.colors.prop('scrollHeight'));
    },

    flash: function (key) {
      var index = -1;
      _.each(this.data.colors, function (c, i) {
        if (index < 0 && colorKey(c) === key) { index = i; }
      });
      var $chip = this.ui.colors.find('.cs-chip').eq(index).addClass('flash');
      setTimeout(function () { $chip.removeClass('flash'); }, 800);
    },

    onRemove: function (e) {
      this.data.colors.splice(parseInt($(e.currentTarget).attr('data-index'), 10), 1);
      this.renderColors();
      if (this.results && this.results.length) {
        this.renderResults();
      }
    },

    // ---- spot colour search --------------------------------------------
    onSearchInput: function () {
      var self = this;
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(function () { self.searchPantones(); }, 250);
    },

    searchPantones: function () {
      var self = this;
      // Answers can come back out of order: only the last search is shown.
      var seq = this.searchSeq = (this.searchSeq || 0) + 1;
      var term = $.trim(this.ui.pantoneSearch.val());
      var library = this.ui.library.val();
      if (!term && !library) {
        this.results = [];
        this.ui.results.html('<div class="cs-hint">' + _.escape(_.i18n('admin.colorSelections.searchHint', null,
          'Type a code or a name, or choose a library.')) + '</div>');
        return;
      }
      App.request('colorSelections:pantones', {
        search: term, library: library, first: 0, pageSize: PAGE_SIZE
      }).done(function (results) {
        if (self.isDestroyed || seq !== self.searchSeq) { return; }
        self.results = results || [];
        self.renderResults();
      });
    },

    renderResults: function () {
      var present = {};
      _.each(this.data.colors, function (c) { present[colorKey(c)] = true; });
      if (!this.results.length) {
        this.ui.results.html('<div class="cs-hint">' +
          _.escape(_.i18n('admin.colorSelections.noResult', null, 'No colour found.')) + '</div>');
        return;
      }
      var html = _.map(this.results, function (c, index) {
        return '<button type="button" class="cs-result js-result' + (present[colorKey(c)] ? ' added' : '') +
          '" data-index="' + index + '" title="' + _.escape(c.library + ' — ' + c.code + (c.name ? ' (' + c.name + ')' : '')) + '">' +
          '<span class="cs-swatch" style="background:' + _.escape(c.hex) + '"></span>' +
          '<span class="cs-result-code">' + _.escape(c.code) + '</span>' +
          '<span class="cs-result-lib">' + _.escape(c.library) +
          (c.custom ? ' · ' + _.escape(_.i18n('admin.colorSelections.custom', null, 'your account')) : '') + '</span></button>';
      }).join('');
      if (this.results.length >= PAGE_SIZE) {
        html += '<div class="cs-hint">' + _.escape(_.i18n('admin.colorSelections.refine', null,
          'First results only: refine the search.')) + '</div>';
      }
      this.ui.results.html(html);
    },

    onAddPantone: function (e) {
      var color = this.results[parseInt($(e.currentTarget).attr('data-index'), 10)];
      if (!color) { return; }
      this.addColor(_.clone(color));
      $(e.currentTarget).addClass('added');
    },

    // ---- plain colour ---------------------------------------------------
    onPickerChange: function () {
      this.ui.rgbHex.val(this.ui.rgbPicker.val());
    },

    onHexInput: function () {
      var hex = normalizeHex(this.ui.rgbHex.val());
      this.ui.rgbHex.toggleClass('invalid', !hex);
      if (hex) {
        this.ui.rgbPicker.val(hex);
      }
    },

    onAddRgb: function () {
      var hex = normalizeHex(this.ui.rgbHex.val());
      if (!hex) {
        this.ui.rgbHex.addClass('invalid').focus();
        return;
      }
      this.addColor({ library: null, code: null, name: null, hex: hex });
    },

    // ---- save -----------------------------------------------------------
    onSave: function () {
      var self = this;
      var payload = {
        code: $.trim(this.ui.code.val()),
        name: $.trim(this.ui.name.val()),
        description: $.trim(this.ui.description.val()),
        colors: _.map(this.data.colors, function (c) {
          return { library: c.library, code: c.code, hex: c.hex };
        })
      };
      if (!payload.code) {
        this.showError(_.i18n('admin.colorSelections.codeRequired', null, 'Please enter a code.'));
        this.ui.code.focus();
        return;
      }
      this.ui.error.hide();
      this.ui.save.prop('disabled', true);
      var request = this.secId ? App.request('colorSelections:update', this.secId, payload) :
        App.request('colorSelections:create', payload);
      request.done(function () {
        if (self.options.onSaved) { self.options.onSaved(); }
        self.onClose();
      }).fail(function (xhr) {
        if (self.isDestroyed) { return; }
        self.ui.save.prop('disabled', false);
        var reason = xhr && xhr.responseJSON && xhr.responseJSON.error;
        self.showError(reason || _.i18n('common.error', null, 'Something went wrong. Please try again.'));
      });
    },

    showError: function (message) {
      this.ui.error.text(message).show();
    },

    onClose: function () {
      if (this.windowView) { this.windowView.close(); }
    }
  });

  View.open = function (secId, onSaved) {
    Windows.open({
      view: function () {
        return new View({ selectionSecId: secId, onSaved: onSaved });
      },
      title: secId ? _.i18n('admin.colorSelections.editTitle', null, 'Colour selection') :
        _.i18n('admin.colorSelections.createTitle', null, 'New colour selection'),
      width: 860,
      height: 740,
      modal: true
    });
  };

  Module.exports = View;
});

